import React, { Component } from 'react'
import { pure } from 'recompose'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Navigation from 'react-toolbox/lib/navigation'
import {IconButton, Button } from 'react-toolbox/lib/button'
import { compose } from 'redux'
import { shallowEqual } from 'helpers/Utils'

import notifyHoc from 'containers/App/Notification/Notify'
import SubFields from './SubFields'
import styles from './styles.scss'

const PureSubFields = pure(SubFields)

const NotifyButton = notifyHoc(IconButton)
class Fields extends Component {
  render() {
    const {
      list, 
      onClick, 
      toggleSectionCollapse, 
      isSectionCollapsed, 
      notCollapseable,
      onDeselectAllSearchFilters,
      selectAllSearchFilters,
      noneChecked,
      searchFieldList,
      disabled,
      expandAllFilters,
      collapseAllFilters,
      collapsedSections,
      selectAllSearchSection} = this.props
  const subnavs = Object.entries(list)
  const expandOrCollapse = collapsedSections === subnavs.length
  return (
    <Navigation theme={styles}>
      {notCollapseable ? "" : 
      <Button
        label={noneChecked ? 'Select all' : 'Clear all'}
        styleName="selectAll"
        icon='select_all' 
        onClick={noneChecked ? selectAllSearchFilters.bind(this, searchFieldList) : onDeselectAllSearchFilters} 
      />}
      {notCollapseable ? "" : 
      <NotifyButton 
        message={"Collapse/Expand all Sections"} 
        styleName='expandAll' 
        theme={styles} 
        icon={expandOrCollapse ? 'unfold_more' : 'unfold_less'} 
        onClick={expandOrCollapse ? collapseAllFilters : expandAllFilters.bind(this, subnavs.length)} 
      />}
      {
        subnavs.map(([subheader, fields], idx) => (
          <PureSubFields 
            key={subheader} 
            caption={subheader} 
            list={fields}
            onClick={onClick}
            toggleSectionCollapse={toggleSectionCollapse}
            idx={idx}
            isSectionCollapsed={isSectionCollapsed}
            notCollapseable={notCollapseable}
            selectAllSearchSection={selectAllSearchSection}
        />)
        )
      }
    </Navigation>
    )
  }
}

Fields.propTypes = {
  list: PropTypes.object.isRequired,
  // isSectionCollapsed: PropTypes.array.isRequired
}

Fields.defaultProps = {
  list: {},
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(Fields)
